export const getOrderArg = (order: Record<string, string>) => {
  const orderKey = Object.keys(order)[0];
  const orderValue = Object.values(order)[0];
  return { [`order[${orderKey}]`]: orderValue };
};
